import { get, post, put, del, patch } from 'aws-amplify/api';
import { fetchAuthSession } from 'aws-amplify/auth';

async function authHeaders(): Promise<Record<string, string>> {
  try {
    const session = await fetchAuthSession();
    const token = session.tokens?.idToken?.toString();
    return token ? { Authorization: token } : {};
  } catch {
    return {};
  }
}

export async function apiGet(path: string) {
  const headers = await authHeaders();
  return get({ apiName: 'ChapteryApi', path, options: { headers } }).response;
}

export async function apiPost(path: string, body?: Record<string, unknown>) {
  const headers = await authHeaders();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return post({ apiName: 'ChapteryApi', path, options: { headers, body: body as any } }).response;
}

export async function apiPut(path: string, body?: Record<string, unknown>) {
  const headers = await authHeaders();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return put({ apiName: 'ChapteryApi', path, options: { headers, body: body as any } }).response;
}

export async function apiPatch(path: string, body?: Record<string, unknown>) {
  const headers = await authHeaders();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return patch({ apiName: 'ChapteryApi', path, options: { headers, body: body as any } }).response;
}

export async function apiDel(path: string) {
  const headers = await authHeaders();
  return del({ apiName: 'ChapteryApi', path, options: { headers } }).response;
}

export async function apiPublicPost(path: string, body?: Record<string, unknown>) {
  // No auth headers — for unauthenticated endpoints like POST /recover
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return post({ apiName: 'ChapteryApi', path, options: { body: body as any } }).response;
}

export async function apiPublicGet(path: string) {
  // No auth headers — for unauthenticated endpoints like GET /articles
  return get({ apiName: 'ChapteryApi', path, options: {} }).response;
}
